import { render, staticRenderFns } from "./SignBatch.vue?vue&type=template&id=66d4b8f3"
import script from "./SignBatch.vue?vue&type=script&lang=js"
export * from "./SignBatch.vue?vue&type=script&lang=js"
import style0 from "./SignBatch.vue?vue&type=style&index=0&id=66d4b8f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports